import React from "react";
import PriceField from "../PriceField";
import InputWithSuggestions from "../../InputWithSuggestions";
import MultiImageField from "../../MultiImageField";

export default function BasicTab({ values, onChange, categories = [] }) {

	function inputChange(e) {
		onChange({ [e.target.name]: e.target.value });
	}

	return <div>
		{/* Editor main */}
		<div className="padded bordered">
			<div className="flexy" style={{ marginBottom: 10 }}>
				<input
					style={{
						flex: 2,
						marginRight: 10
					}}
					type="text"
					name="name"
					placeholder="Name"
					value={values.name || ""}
					onChange={inputChange}
				/>
				<PriceField
					style={{
						flex: 1,
						marginleft: 10
					}}
					placeholder="Price"
					value={values.price || 0}
					onChange={value => onChange({ price: value })}
				/>
			</div>
			<InputWithSuggestions
				value={values.category}
				onChange={value => onChange({ category: value })}
				placeholder="Category"
				suggestions={categories}
			/>
		</div>

		{/* Images and description */}
		<div className="flexy wrapping">
			<div className="padded bordered bordered-right" style={{ minWidth: 250 }}>
				<MultiImageField
					value={values.images}
					onChange={images => {
						onChange({ images });
					}}
				/>
			</div>
			<div className="padded bordered" style={{ minWidth: 250 }}>
				<textarea
					style={{ resize: "none", height: "100%" }}
					type="text"
					name="description"
					placeholder="Description"
					value={values.description || ""}
					onChange={inputChange}
				/>
			</div>
		</div>
	</div>
}